import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";

export const friendReferralSlice = createSlice({
	name: "friend-referral",
	initialState,
	reducers: {
		setIsCheckingFr: (state, action: PayloadAction<boolean>) => {
			state.isCheckingFr = action.payload;
		}
	}
});

export const { setIsCheckingFr } = friendReferralSlice.actions;

export default friendReferralSlice.reducer;
